export default __webpack_public_path__ + "static/media/ico-1.e555940c.svg";